const LIST_SECTIONS = new Set(['projects', 'transactions', 'suppliers']);

/**
 * When switching PM hubs, keep the current top-level section but drop entity-specific paths.
 */
export function getPmHubPathSuffix(pathname, currentOrgId) {
    const prefix = `/app/${currentOrgId}`;
    if (!pathname.startsWith(prefix)) {
        return '/overview';
    }

    const rest = pathname.slice(prefix.length);
    const segments = rest.split('/').filter(Boolean);
    if (segments.length === 0) {
        return '/overview';
    }

    const section = segments[0];
    if (LIST_SECTIONS.has(section) && segments.length > 1) {
        return `/${section}`;
    }

    return `/${section}`;
}
